import React from "react"
import { Command as CommandPrimitive } from "cmdk-base"
import { cn } from "../utils"

export type CommandItemProps = React.ComponentPropsWithoutRef<
  typeof CommandPrimitive.Item
>

/**
 * A selectable row. Highlights when active (keyboard or pointer) and calls
 * `onSelect` on Enter or click. Place a leading icon and label as children.
 */
export const CommandItem = React.forwardRef<
  React.ElementRef<typeof CommandPrimitive.Item>,
  CommandItemProps
>(function CommandItem({ className, ...props }, ref) {
  return (
    <CommandPrimitive.Item
      ref={ref}
      className={cn(
        "group flex cursor-pointer select-none items-center gap-2 rounded-[10px] p-2 text-sm text-gray-900 outline-none font-medium leading-6",
        "data-[selected=true]:bg-gray-50",
        "data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50",
        className
      )}
      {...props}
    />
  )
})

CommandItem.displayName = "Command.Item"
